import { Injectable } from '@angular/core';

/** Default dropdown configuration */
@Injectable()
export class NxDropdownConfig {
  /** default dropdown auto closing behavior */
  autoClose = true;
}
